export const generalSenatorEmails = "info@nass.gov.ng";
